module.exports = __webpack_public_path__ + "img/shape-metal_ag-mobile@2x.ed344c19.png";